/** Lodge list menus (location picker, print dialog submenu). Keep in sync with v2-shell.css (20rem). */
export const ADMIN_TOOLBAR_MENU_MAX_HEIGHT = 520
